import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var MeasurementIcon = function MeasurementIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.83 2.279l4.891 4.89a2.658 2.658 0 0 1 0 3.76L10.928 21.72a2.658 2.658 0 0 1-3.759 0l-4.89-4.89a2.658 2.658 0 0 1 0-3.76L13.072 2.28a2.658 2.658 0 0 1 3.759 0zm-2.698 1.06L12.641 4.83l3.64 3.64a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073-3.64-3.639-2.314 2.314 2.514 2.515a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073-2.515-2.514-2.314 2.314 3.64 3.64a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-1.06 0l-3.64-3.639-1.49 1.491a1.158 1.158 0 0 0 0 1.638l4.89 4.89a1.158 1.158 0 0 0 1.638 0L20.66 9.869a1.158 1.158 0 0 0 0-1.638l-4.89-4.89a1.158 1.158 0 0 0-1.639 0z"
  }));
};

MeasurementIcon.displayName = 'MeasurementIcon';
export default MeasurementIcon;